<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers /></el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!-- Page Header -->
							<div class="page_header">
								View Document
							</div>
				
							<div class="page_main" v-if="info">
								<el-form ref="form" :model="info" label-position="top" class="request-form">
				
									<div class="form-grid">
										<!-- Left -->
										<div class="form-col">
											<el-form-item label="Document ID">
												<div class="gray-input">
													{{ info.ref }}
												</div>
											</el-form-item>
										</div>
				
										<!-- Right -->
										<div class="form-col">
											<el-form-item label="Revision">
												<div class="gray-input">
													{{ info.vnumber || "/" }}
												</div>
											</el-form-item>
										</div>
									</div>
				
									<!-- Description -->
									<el-form-item label="Document Name" class="full-width-item">
										<div class="gray-input">
											{{ info.vname || "/" }}
										</div>
									</el-form-item>
				
									<el-form-item label="Document Type" class="full-width-item">
										<div class="gray-input">
											{{ info.leixing_name || "/" }}
										</div>
									</el-form-item>
				
									<!-- Company -->
									<!-- <el-form-item label="Company">
										<div class="gray-input">
											{{ info.company_name || "/" }}
										</div>
									</el-form-item> -->
				
									<!-- Department -->
									<el-form-item label="Department">
										<div class="gray-input">
											{{ info.departments_name || "/" }}
										</div>
									</el-form-item>
				
									<el-form-item label="Document File">
										<div v-if="info.image_info">
											<el-input v-model="info.image_info.name" readonly></el-input>
				
											<div class="file-row">
												<div class="file-link" @click="viewFile(info.image_info.url)">
													View
												</div>
				
												<div :class="info.status == 3 ? 'file-success' : 'file-warning'">
													{{ info.shuoming }}
												</div>
											</div>
										</div>
				
										<div v-else class="file-row">
											<div class="no-file">
												No File Uploaded
											</div>
				
											<div class="file-warning">
												This revision is not the final released version.
											</div>
										</div>
									</el-form-item>
				
									<div class="text-tip">
										Document Status
									</div>
				
									<div class="form-grid">
				
										<!-- Left -->
										<div class="form-col">
											<el-form-item label="Status">
												<div class="gray-input" v-if="info.status == 1">
													Proposed
												</div>
				
												<div class="gray-input" v-if="info.status == 2">
													Pending Effectiveness
												</div>
				
												<div class="gray-input" v-if="info.status == 3">
													Effective
												</div>
				
												<div class="gray-input" v-if="info.status == 4">
													Superseded
												</div>
				
												<div class="gray-input" v-if="info.status == 5">
													Obsolete
												</div>
											</el-form-item>
										</div>
				
										<!-- Right -->
										<div class="form-col">
											<el-form-item label="Effective Date">
												<div class="gray-input">
													{{ formatDate(info.effective_time) }}
												</div>
											</el-form-item>
										</div>
				
									</div>
				
									<!-- Approvers -->
									<div class="table-card">
										<div class="table-card-header">
											<div class="table-title">
												Change Request Approvers
											</div>
										</div>
				
										<el-table
											:data="applyTableData"
											border
											stripe
											header-cell-class-name="table-header-cell"
											class="history-table">
				
											<!-- <el-table-column label="Company" sortable min-width="220">
												<template slot-scope="scope">
													{{ scope.row.company_name || "/" }}
												</template>
											</el-table-column> -->
				
											<el-table-column label="Department" sortable min-width="220">
												<template slot-scope="scope">
													{{ scope.row.departments_name || "/" }}
												</template>
											</el-table-column>
				
											<el-table-column label="Task Status / Result" sortable min-width="220">
												<template slot-scope="scope">
													<div v-if="scope.row.status == 1">In Progress</div>
													<div v-if="scope.row.status == 2">Approved</div>
													<div v-if="scope.row.status == 3">Rejected</div>
													<div v-if="scope.row.status == 4">Auto Rejected</div>
													<div v-if="scope.row.status == 9">Withdrawn</div>
												</template>
											</el-table-column>
				
											<el-table-column
												prop="username"
												label="Assignee"
												sortable
												min-width="160" />
				
											<el-table-column
												prop="end_time"
												label="Due Date"
												min-width="160" />
				
											<el-table-column
												prop="app_time"
												label="Completion Date"
												min-width="200" />
										</el-table>
									</div>
				
									<!-- Revision History -->
									<div class="table-card">
										<div class="table-card-header">
											<div class="table-title">
												Document Revision History
											</div>
										</div>
				
										<el-table
											:data="revisionTableData"
											border
											stripe
											header-cell-class-name="table-header-cell"
											class="history-table">
				
											<el-table-column label="Revision" sortable min-width="220">
												<template slot-scope="scope">
													<div v-if="info.vnumber == scope.row.vnumber">
														{{ scope.row.vnumber }}
													</div>
				
													<div
														v-else
														style="text-decoration: underline;color:#409EFF;cursor:pointer;"
														@click="goHistory(scope.row)">
														{{ scope.row.vnumber }}
													</div>
												</template>
											</el-table-column>
				
											<el-table-column label="Status" sortable min-width="220">
												<template slot-scope="scope">
													<div v-if="scope.row.status == 1">Proposed</div>
													<div v-if="scope.row.status == 2">Pending Effectiveness</div>
													<div v-if="scope.row.status == 3">Effective</div>
													<div v-if="scope.row.status == 4">Superseded</div>
													<div v-if="scope.row.status == 5">Obsolete</div>
													<div v-if="scope.row.status == 9">Withdrawn</div>
												</template>
											</el-table-column>
				
											<el-table-column
												prop="effective_time"
												label="Effective Date"
												sortable
												min-width="160"
												:formatter="dateFormat" />
				
											<el-table-column
												prop="request_id"
												label="Original Change Request"
												min-width="160" />
				
											<el-table-column
												prop="vdesc"
												label="Change Description"
												min-width="200" />
				
										</el-table>
									</div>
				
									<!-- Task History -->
									<div class="table-card" v-if="originTableData.length > 0">
										<div class="table-card-header">
											<div class="table-title">
												Task History
											</div>
										</div>
				
										<el-table
											:data="originTableData"
											border
											stripe
											header-cell-class-name="table-header-cell"
											class="history-table">
				
											<el-table-column
												prop="taskName"
												label="Task Name"
												sortable
												min-width="220" />
				
											<el-table-column
												prop="department"
												label="Department"
												sortable
												min-width="220" />
				
											<el-table-column
												prop="status"
												label="Task Status / Result"
												sortable
												min-width="160" />
				
											<el-table-column
												prop="comment"
												label="Comment"
												sortable
												min-width="160" />
				
											<el-table-column
												prop="owner"
												label="Assignee"
												sortable
												min-width="200" />
				
											<el-table-column
												prop="deadline"
												label="Due Date"
												sortable
												min-width="120" />
				
											<el-table-column
												prop="finishDate"
												label="Completion Date"
												sortable
												min-width="100" />
				
										</el-table>
									</div>
				
									<div class="footer-btn">
										<el-button type="primary" @click="handleClose">
											Close
										</el-button>
									</div>
				
								</el-form>
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading">
				<van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import headers from "@/component/header.vue";
import slider from "@/component/slider.vue";
import { resourcesDetail } from "@/api/docManage/documentSearch/index";
import moment from "moment";
moment.locale("zh-cn");

export
default {
	components: {
		headers,
		slider,
	},
	data() {
		return {
			isLoading: true,
			revisionTableData: [],
			applyTableData: [],
			info: {},
			originTableData: [],
			vid: "",
		};
	},
	created() {
		let that = this;
		that.vid = that.$route.query.id;
	},
	mounted() {
		let that = this;
		that.getDocumentDetail();
	},
	watch: {
		//
	},
	methods: {
		formatDate(date) {
			if (!date || date === 0) {
				return "/";
			}
			return moment(date * 1000).format("YYYY-MM-DD");
		},
		//时间格式化
		dateFormat: function(row, column) {
			let that = this;
			var date = row[column.property];
			if (date == undefined || date == 0) {
				return "/";
			}
			return moment(date * 1000).format("YYYY-MM-DD");
		},
		getDocumentDetail() {
			let that = this;
			resourcesDetail({
				vid: that.vid,
			}).then((res) => {
				if (res.code == 200) {
					// console.log("********", res);
					that.info = res.data;
					that.revisionTableData = res.data.vlist;
					that.applyTableData = res.data.applylist;
				}
				that.isLoading = false;
			});
		},
		handleClose() {
			let that = this;
			window.close();
		},
		//跳转历史版本
		goHistory(value) {
			let that = this;
			const routeData = that.$router.resolve({
				path: "/DocControl/documentsDetail",
				query: { id: value.vid },
			});
			window.open(routeData.href, "_blank");
		},
		//查看文件
		viewFile(value) {
			window.open(value);
		},
		//跳转页面
		goUrl(url) {
			let that = this;
			that.$router.push(url);
		},
	},
};
</script>

<style lang="less" scoped>
//主要内容
.main_main {
  .page_main {
    padding: 18px 20px;

    .btn_el {
      margin: 10px 0 20px 0;

      .tips {
        padding: 6px 8px;
        background-color: #ffb1001a;
        border-radius: 6px;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }

  //页头
  .page_header {
    padding: 0 20px;
    height: 60px;
    line-height: 60px;
    background-color: #d8e4f0;
    font-size: 24px;
    font-weight: bold;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
  }
}
</style>
<style scoped>
.main_box {
  height: calc(100vh - 60px);
  overflow-y: auto;
}

.main_box .main_main {
  position: relative;
  min-height: calc(100% - 0px);
  max-height: auto;
  background-color: #fafafa;
}

.el-header,
.el-main {
  padding: 0;
}

::v-deep .btn span {
  text-decoration: underline;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 28px;
  align-items: start;
}

.form-col {
  display: flex;
  flex-direction: column;
}

.full-width-item {
  margin-top: 8px;
}

/* label 样式 */
::v-deep .el-form-item__label {
  padding-bottom: 8px;
  font-size: 14px;
  line-height: 20px;
  color: #2f343b;
  font-weight: 700;
}

::v-deep .el-input__inner {
  height: 40px;
  line-height: 40px;
  border-radius: 8px;
  background: #e9ecef;
  border: 1px solid #cfd5db;
  color: #2f343b;
}

/* 输入框统一风格 */
.gray-input {
  background: #e9ecef;
  border: 1px solid #cfd5db;
  color: #2f343b;
  border-radius: 8px;
  padding-left: 15px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
}

.text-tip {
  background-color: #fafafa;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
}

.table-card {
  margin-top: 16px;
  border: 1px solid #d8dde3;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
}

.table-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 14px 10px;
  background: #f5f6f7;
  border-bottom: 1px solid #d8dde3;
}

.table-title {
  font-size: 18px;
  font-weight: 700;
  color: #2f343b;
}

.table-tools {
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-input {
  width: 230px;
}

.search-input ::v-deep .el-input__inner {
  border-radius: 8px;
  border: 1px solid #cfd5db;
  height: 40px;
  line-height: 40px;
}

.file-row {
  display: flex;
  align-items: center;
  margin-top: 8px;
  line-height: 20px;
}

/* 查看按钮 */
.file-link {
  color: #409eff;
  font-size: 14px;
  cursor: pointer;
  margin-right: 12px;
  user-select: none;
}

.file-link:hover {
  color: #66b1ff;
  text-decoration: underline;
}

.file-warning {
  color: #d9001b;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  padding: 2px 8px;
}
.file-success {
  color: #67C23A;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  padding: 2px 8px;
}

.no-file {
  color: #909399;
  font-size: 14px;
  margin-right: 12px;
}

.document-table {
  width: 100%;
}

.document-table ::v-deep .custom-table-header {
  background: #f4f6f8;
  color: #2f343b;
  font-weight: 700;
  font-size: 14px;
  border-bottom: 2px solid #3c4043;
}

.document-table ::v-deep .custom-table-cell {
  color: #2f343b;
  font-size: 14px;
}

.document-table ::v-deep .el-table__cell {
  padding: 12px 8px;
}

.document-table ::v-deep .cell {
  word-break: break-word;
  line-height: 1.5;
}

.footer-btn {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
}
</style>